import { FormationDetailProps } from '@/types/formation';

export const espaceConfineFormation: FormationDetailProps = {
  id: '21',
  title: 'Formation Espace Confiné',
  description: "Apprenez à identifier les risques spécifiques aux espaces confinés, à utiliser les équipements adaptés et adoptez les comportements sécuritaires lors des interventions en espace confiné.",
  duration: '7 heures (1 journée)',
  category: 'Sécurité',
  imageSrc: '/images/formations/espaceconfine.webp',
  slug: 'espace-confine',
  reference: 'F-EC R472 R447 R435',
  price: 'Sur devis – nous contacter',
  targetAudience: "Toute personne amenée à travailler dans des espaces confinés",
  prerequisites: 'Être âgé de 18 ans\nÊtre apte médical',
  objectives: [
    "Identifier les risques spécifiques liés aux gaz en espace confiné",
    "Savoir manipuler un détecteur à gaz",
    "Former des surveillants et intervenants à intervenir en espace confiné dans les entreprises",
    "Être capable d'élaborer une intervention en espace confiné",
    "Assurer une présence constante et maintenir des conditions d'intervention jusqu'à la remontée des intervenants",
    "Maîtriser les procédures d'alerte et de secours",
  ],
  program: [
    {
      title: 'Partie théorique 40%',
      items: [
        "Identifier les principaux dangers et risques liés à l'atmosphère et aux moyens mis par l'entreprise",
        "Identifier les autres dangers essentiels aux interventions en espace confiné",
        "Identifier les rôles et missions du surveillant et de l'intervenant",
        "Mettre en place les moyens de protection collective et individuelle et savoir les utiliser",
        "Mettre en place l'encadrement et le balisage",
        "Notion sur les règles d'intervention et du nombre d'agents qui ne doit pas être inférieur à 2",
      ]
    },
    {
      title: 'Partie pratique 60%',
      items: [
        "Mise en service d'un détecteur de gaz",
        "Mise en service des appareils",
        "Interprétation des résultats",
        "Mise en place de l'équipe, rôle chacun, organisation générale du chantier",
        "Mise en place des moyens de protection collective et individuelle et savoir les utiliser",
        "Mise en place de vérification matérielle",
        "Mise en place de surveillance des intervenants",
        "Mise en place des documents obligatoires (permis de pénétrer)",
        "Mise en situation dans un espace confiné",
      ]
    },
  ],
  pedagogicalMethods: [
    'Exposés interactifs, démonstrations par le formateur, mise en situation pratique, exercice sur site',
  ],
  evaluationMethods: [
    "1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    'Pendant la formation : Atelier pratique en situation réelle + exercice applicable',
    'Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud',
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant",
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par l'apprenant.",
  registrationProcess: [
    'Inscription par téléphone, par email ou par le site internet',
    "Délai d'accès selon un agenda interne (10 jours avant le début de la formation)",
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap. Nous sommes susceptibles d'accueillir des personnes ayant ce mode nous contacter au préalable pour étudier toute situation.",
  intervenant: "Formateur spécialisé en sécurité incendie",
  formatterInfo: {
    name: 'Sebastien Davrainville - SDPSI Formation',
    phone: '06 22 61 54 80',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsi-formations.fr'
  },
  numberOfParticipants: "Variable",
  effectif: "Variable"
};
